export default {
  ticketStates: null,
  ticketStatesMap: {},
  orderStates: null,
  orderStatesMap: {},
};
